import DOM_SELECTOR_CONFIG from '../config/domSelectorConfig';

const CONTENT_NODE = DOM_SELECTOR_CONFIG.CONTENT_DATA_SELECTORS;
const QUESTION_NODE = DOM_SELECTOR_CONFIG.QUESTION_DATA_SELECTORS;
const INPUT_NODE = DOM_SELECTOR_CONFIG.INPUT_DATA_SELECTORS;
const PAGE_NODE = DOM_SELECTOR_CONFIG.PAGE_DATA_SELECTORS;
const REDIRECT_NODE = DOM_SELECTOR_CONFIG.REDIRECT_DATA_SELECTORS;

const domSelector = {
  getContentContainer: function() {
    return document.body.querySelector(`[data-view="${CONTENT_NODE.CONTENT_VIEW}"]`);
  },
  getContentContinueButton: function() {
    return document.body.querySelector(`[data-navigation="${CONTENT_NODE.CONTINUE_BUTTON}"]`);
  },
  getPPFBody: function() {
    return document.body.querySelector(`#${DOM_SELECTOR_CONFIG.PPF_BODY_ID_SELECTOR}`);
  },
  getNavbar: function() {
    return document.body.querySelector(`#${DOM_SELECTOR_CONFIG.NAVBAR_SELECTOR}`);
  },
  getNavbarButtons: function() {
    return document.body.querySelector(`#${DOM_SELECTOR_CONFIG.NAVBAR_BUTTONS_SELECTOR}`);
  },
  getNavbarLogo: function() {
    return document.body.querySelector(`#${DOM_SELECTOR_CONFIG.NAVBAR_BABBEL_LOGO_SELECTOR}`);
  },
  getProgressBar: function() {
    return document.body.querySelector(`#${DOM_SELECTOR_CONFIG.PROGRESS_BAR_SELECTOR}`);
  },
  getQuestionContainer: function() {
    return document.body.querySelector(`[data-view="${QUESTION_NODE.QUESTION_VIEW}"]`);
  },
  getQuestionAnswersContainer: function() {
    return document.body.querySelector(`[data-sub-view="${QUESTION_NODE.ANSWERS_SUBVIEW}"]`);
  },
  getQuestionContinueButton: function() {
    return document.body.querySelector(`[data-navigation="${QUESTION_NODE.CONTINUE_BUTTON}"]`);
  },
  getInputContainer: function() {
    return document.body.querySelector(`[data-view="${INPUT_NODE.INPUT_VIEW}"]`);
  },
  getInputPartialsContainer: function() {
    return document.body.querySelector(`[data-sub-view="${INPUT_NODE.PARTIALS_SUBVIEW}"]`);
  },
  getInputPartialContainer: function(partialName) {
    return document.body.querySelector(`[data-sub-view="${this.getInputPartialSelector(partialName)}"]`);
  },
  getInputPartialSelector: function(partialName) {
    return `${INPUT_NODE.PARTIAL_CONTAINER}${partialName}`;
  },
  getInputContinueButton: function() {
    return document.body.querySelector(`[data-navigation="${INPUT_NODE.CONTINUE_BUTTON}"]`);
  },
  getLoginButton: function() {
    return document.body.querySelector(`[data-element="login"]`);
  },
  getPageContainer: function() {
    return document.body.querySelector(`[data-view="${PAGE_NODE.PAGE_VIEW}"]`);
  },
  getPageContinueButton: function() {
    return document.body.querySelector(`[data-navigation="${PAGE_NODE.CONTINUE_BUTTON}"]`);
  },
  getRedirectContainer: function() {
    return document.body.querySelector(`[data-view="${REDIRECT_NODE.REDIRECT_VIEW}"]`);
  },
  getRegisterButton: function() {
    return document.body.querySelector(`[data-element="register"]`);
  },
  getSkipRegisterButton: function() {
    return document.body.querySelector(`[data-element="skip-register"]`);
  },
  getTipsButton: function(nodeType) {
    return document.body.querySelector(`[data-popup="${DOM_SELECTOR_CONFIG.TIP_ICON_SELECTOR} ${nodeType || ''}"]`);
  },
  getPopupContainer: function() {
    return document.body.querySelector('[class="popup-overlay"]');
  },
  getPageAnswerButtons: function() {
    return Array.from(document.body.querySelectorAll(`[data-action="${PAGE_NODE.ANSWER_BUTTON}"]`));
  },
  getTextExpanderLink: function() {
    return document.body.querySelector(`[data-element="content-expander"]`);
  },
  getSigninLink: function() {
    return document.body.querySelector(`[data-element="signin"]`);
  },
  getSignInLink: function(nodeType) {
    return document.body.querySelector(`[data-element="signin-${nodeType}"]`);
  },
  getContentTextElement: function() {
    return document.body.querySelector(`[data-element="content-text"]`);
  },
  getCardButtons: function() {
    return Array.from(document.body.querySelectorAll('[data-element="card-button"]'));
  },
  getOauthButtons: function() {
    return Array.from(document.body.querySelectorAll('[data-oauth]'));
  },
  getLanguageSelectionLinks: function() {
    return Array.from(document.body.querySelectorAll('[data-element="language-selection"]'));
  }
};

export default domSelector;
